import { render, staticRenderFns } from "./role_form.vue?vue&type=template&id=60d112f8&"
import script from "./role_form.vue?vue&type=script&lang=js&"
export * from "./role_form.vue?vue&type=script&lang=js&"
import style0 from "./role_form.vue?vue&type=style&index=0&id=60d112f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports